import React from "react";
import { Loader2 } from "lucide-react";
import AdminLeadRow from "./AdminLeadRow";

export default function LeadsTable({
  loading,
  leads,
  onRowClick,
  approving,
  rejecting,
  showApproveDialog,
  showRejectDialog,
  onApprove,
  onReject,
  onOpenApproveDialog,
  onOpenRejectDialog
}) {
  return (
    <div className="card">
      {loading && (!leads || leads.length === 0) ? (
        <div className="table-wrapper">
          <table className="table">
            <thead>
              <tr>
                {[...Array(7)].map((_, i) => (
                  <th key={i}>
                    <div className="h-4 w-20 bg-gray-200 rounded animate-pulse" />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[...Array(5)].map((_, i) => (
                <tr key={i}>
                  {[...Array(7)].map((_, j) => (
                    <td key={j}>
                      <div className="h-4 w-full bg-gray-100 rounded animate-pulse" />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className={`table-wrapper ${loading ? 'opacity-50 transition-opacity duration-200' : ''}`}>
          <table className="table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Lead Maker</th>
                <th>Segment</th>
                <th>Total</th>
                <th>Status</th>
                <th>Commission</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {leads?.map((l) => (
                <AdminLeadRow
                  key={l.id}
                  lead={l}
                  onClick={onRowClick}
                  approving={approving[l.id]}
                  rejecting={rejecting[l.id]}
                  showApproveDialog={showApproveDialog[l.id]}
                  showRejectDialog={showRejectDialog[l.id]}
                  onApprove={() => onApprove(l.id)}
                  onReject={() => onReject(l.id)}
                  onOpenApproveDialog={(open) => onOpenApproveDialog(l.id, open)}
                  onOpenRejectDialog={(open) => onOpenRejectDialog(l.id, open)}
                />
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

